import { STORE_IMAGE_LIST } from "./actionTypes"

const INIT_STATE = {
  imageList: [],
}

const Sheet = (state = INIT_STATE, action) => {
  switch (action.type) {
    case STORE_IMAGE_LIST:
      return { ...state, imageList: action.payload }

    default:
      return state
  }
}

export default Sheet
